import { Component, computed, input, model, output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { IContentCardItem } from './content.interface';

@Component({
  selector: 'app-content-adapter',
  template: '',
})
export class ContentAdatper {
  content = input<IContentCardItem>();
  content$ = toObservable(this.content);
  favorite = output<void>();
  categoryName = computed(() =>
    typeof this.content()?.category === 'string'
      ? this.content()?.category
      : (this.content()?.category as any)?.name,
  );

  isFavorite = model(false);
  favoriteCount = model(0);

  constructor() {
    this.content$.subscribe((content) => {
      if (content) {
        this.isFavorite.set(content.isFavorite || false);
        this.favoriteCount.set(content.favoriteCount || 0);
      }
    });
  }

  handleFavorite() {
    this.isFavorite.set(!this.isFavorite());
    this.favoriteCount.set(
      this.isFavorite() ? this.favoriteCount() + 1 : this.favoriteCount() - 1,
    );
    this.favorite.emit();
  }
}
